export enum FlatCommissionType {
  Percentage = 'Percentage',
  FlatFee = 'FlatFee',
}

export interface FlatCommission {
  flatCommissionType: FlatCommissionType;
  amount?: number;
}
